// Kurátorský seznam „našeptaných dotazů" (searchSuggest.js). Reálné dotazy
// z vlastního logu ho nahradí v #88 — do té doby jde o ruční výběr z designu.
export default {
  // Pořadí z mockupu Vyhledávání.dc.html.
  popular: ['pila', 'křovinořez', 'kompresor', 'svářečka', 'topidlo', 'žebřík', 'tlaková myčka'],
};
